"use strict";

import Vue from 'vue';
import axios from "axios";
import Qs from "qs";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  // SPA is served same-origin under /app/, so /api/ is on the same Django host.
  baseURL: process.env.VUE_APP_BASE_URL || '/api/',
  responseType: 'json',
  paramsSerializer: {
    serialize: (params) => Qs.stringify(params, {arrayFormat: 'repeat'})
  },
  // Django CSRF: read csrftoken cookie and send as X-CSRFToken header
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  /*
  auth: {
    username: 'demo',
    password: 'demo'
  }*/
  pushApplicationServerKey: process.env.VUE_APP_PUSH_APPLICATION_SERVER_KEY
};

const _axios = axios.create(config);
Vue.prototype.$api = _axios;

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    let token = localStorage.getItem('speaker_tool_token')
    if (token)
      config.headers.Authorization = `Token ${token}`;
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Redirect to login on 401 (invalid/expired token)
let _redirecting = false
function handle401(error) {
  if (error.response && error.response.status === 401 && !_redirecting) {
    _redirecting = true
    localStorage.removeItem('speaker_tool_token')
    localStorage.removeItem('speaker_tool_user')
    localStorage.removeItem('user_uuid')
    localStorage.removeItem('direct-channels')
    localStorage.removeItem('contact-ids')
    // BASE_URL = publicPath ('/app/'): the SPA login route only exists under it
    window.location.href = process.env.BASE_URL + 'login?next=' + encodeURIComponent(window.location.pathname)
  }
  return Promise.reject(error)
}

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    return response;
  },
  handle401
);

//Plugin.install = function(Vue, options) {
Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
